import { useInvalidatePortfolios } from '@/entities/portfolio';
import { trpc } from '@/shared/api';
import { useAsyncAction } from '@/shared/lib';

export const useSetPortfolioVisibility = () => {
  const mutation = trpc.portfolioManagement.items.setVisibility.useMutation();
  const action = useAsyncAction(mutation.mutateAsync, useInvalidatePortfolios());
  return { ...action, setVisibility: action.execute };
};
